const state = {
  products: [],
};

const getters = {
  getCartItems(state) {
    return state.products;
  },
  getCartTotalItems(state) {
    let qty = 0;
    state.products.forEach((item) => {
      qty += item.qty;
    });
    return qty;
  },
  getCartTotalPrice(state) {
    let price = 0;
    state.products.forEach((item) => {
      price += item.sub_total;
    });
    return price;
  },
  getCartTotalCost(state) {
    let cost = 0;
    state.products.forEach((item) => {
      cost += item.cost * item.qty;
    });
    return cost;
  },
};

const actions = {
  setCartItems({ commit }, payload) {
    commit('SET_PRODUCTS', payload);
  },
  unsetCartItems({ commit }) {
    commit('REMOVE_PRODUCTS');
  },
  setCartItem({ commit }, payload) {
    commit('ADD_PRODUCT', payload);
  },
  unsetCartItem({ commit }, payload) {
    commit('REMOVE_PRODUCT', payload);
  },
  updateCartItem({ commit }, payload) {
    commit('ITEM_UPDATE', payload);
  },
};

const mutations = {
  SET_PRODUCTS(state, items) {
    state.products = items;
  },
  REMOVE_PRODUCTS(state) {
    state.products = [];
  },

  ITEM_UPDATE(state, item) {
    state.products.map((product) => {
      if (item.id === product.id && item.name === product.name && item.title === product.title) {
        product.sub_total = product.qty * product.price;
      }
    });
  },
  ADD_PRODUCT(state, item) {
    let cat = {
      id: item.id,
      name: item.name,
      sku: item.sku,
      upc: item.upc,
      attribute_id: item.attribute_id ?? null,
      title: item.title ?? null,
      serial_number: item.serial_number ?? null,
      identity: item.identity ?? null,
      image: item.image,
      price: Number(item.price),
      cost: Number(item.cost),
      in_stock: item.in_stock,
      qty: 0,
      sub_total: 0,
      data: item,
    };

    state.products.map((product) => {
      if (product.title) {
        if (item.id === product.id && item.name === product.name && item.title === product.title) {
          cat = product;
          state.products.splice(state.products.indexOf(cat), 1);
        }
      } else {
        if (item.id === product.id && item.name === product.name) {
          cat = product;
          state.products.splice(state.products.indexOf(cat), 1);
        }
      }
    });

    cat.qty++;
    cat.sub_total = cat.qty * cat.price;
    state.products.push(cat);
  },

  REMOVE_PRODUCT(state, product) {
    state.products.splice(state.products.indexOf(product), 1);
  },
};
export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
